/* eslint-disable react/prop-types */
import { DialogContent, DialogContentText, Link, Stack } from "@mui/material";
import { TimedProgressBar } from "./index";
import DialogHeader from "./dialogHeader";
import translations from "../translations";

export default function LoadingDialog({
  progress,
  setProgress,
  ms,
  handleClose,
  isClosable = true,
}) {
  const locale = window.authSettings ? window.authSettings.locale : "fr-FR";
  const translation = translations.getTranslations(locale);

  return (
    <>
      <DialogHeader
        title={translation.loadingDialog.title}
        handleClose={handleClose}
        isClosable={isClosable}
      />
      <DialogContent sx={{ display: "flex", width: "-webkit-fill-available" }}>
        <Stack display={"flex"} width={"100%"}>
          <DialogContentText
            id="loading-dialog-estimation"
            className="intelligent-profile-dialog-text"
            marginBottom={2}
            display={"flex"}
          >
            {translation.loadingDialog.description}
          </DialogContentText>
          <TimedProgressBar
            progress={progress}
            setProgress={setProgress}
            ms={ms}
          />
          <DialogContentText
            id="loading-dialog-description"
            className="intelligent-profile-dialog-text"
            marginTop={3}
            display={"flex"}
          >
            {translation.loadingDialog.description2}
          </DialogContentText>
        </Stack>
      </DialogContent>
      <Stack
        direction="row"
        justifyContent="center"
        alignItems="center"
        marginBottom={3}
      >
        <Link href={`#/`}>{translation.loadingDialog.navigation}</Link>
      </Stack>
    </>
  );
}
